var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{attrs:{"src":require("@/assets/images/logo/logo.svg"),"fluid":"","alt":"Industry System"}})}
var staticRenderFns = []

export { render, staticRenderFns }